// ---------------- Start External Library Import --------------------//
import React from 'react';
import PropTypes from 'prop-types';
import CantSignIn from '@techsoftware/happay-widgets/CantSignin';
import history from '../../utils/history';

const CantSignInPage = props => {
  const { productLogo, privacyPolicyUrl, termOfUseUrl } = props;
  return (
    <CantSignIn
      containerClassName="signin-container"
      logo={productLogo}
      // breakPoints={breakPoints}
      onClickBack={() => {
        history.goBack();
      }}
      privacyPolicyUrl={privacyPolicyUrl}
      termOfUseUrl={termOfUseUrl}
      privacyPolicyText="Privacy Policy"
      termOfUseText="Terms of Use"
      // cantSignInHeader={i18n.t("logIn.cantSignIn?")}
      // cantSignInSubHeaderOne={i18n.t("err.youCanSign")}
      // cantSignInSubHeaderTwo={i18n.t("err.ifYouStill")}
      // backButtonText={i18n.t("btn.back")}
    />
  );
};
export default CantSignInPage;

CantSignInPage.propTypes = {
  productLogo: PropTypes.node,
  privacyPolicyUrl: PropTypes.string,
  termOfUseUrl: PropTypes.string,
};
